
import { EAdmissionPermission } from "@/models/admission/permission";
import { Component, Vue } from "vue-property-decorator";

import VGeneralTestings from "./general/Testings.vue";
import VProgramTestings from "./program/Testings.vue";

interface ITab {
  id: number;
  value: string;
}

@Component({
  name: "VTestings",
  components: {
    VGeneralTestings,
    VProgramTestings
  }
})
export default class VTestings extends Vue {
  private watchers: Function[] = [];

  public tabs: ITab[] = [];
  public current_type_id: number | null = null;

  public changeTab(tab_id: number) {
    this.current_type_id = tab_id;

    this.$router.replace({ query: { tab_id: `${this.current_type_id}` } });
  }

  private parseQueryTabId() {
    const query_tab_id = this.$route.query.tab_id;
    let tab_id: string | number | null = null;

    if (query_tab_id?.length) {
      tab_id = Array.isArray(query_tab_id) ? query_tab_id[0] : query_tab_id;

      tab_id = parseInt(tab_id ?? "", 10);
    }

    if (tab_id && !Number.isNaN(tab_id)) {
      if (this.tabs.findIndex(tab => tab.id == tab_id) !== -1) {
        this.current_type_id = tab_id;
      }
    }

    if (this.current_type_id == null) {
      this.current_type_id = this.tabs[0].id;
    }
  }

  private setTabs() {
    if (this.$api.hasPermissions([EAdmissionPermission.TESTINGS])) {
      this.tabs.push({
        id: 0,
        value: "Общее тестирование"
      });
    }

    if (
      this.$api.hasPermissions(
        [
          // EAdmissionPermission.TESTINGS,
          // EAdmissionPermission.EDUCATION_PROGRAMS
          "admin"
        ],
        false
      )
    ) {
      this.tabs.push({
        id: 1,
        value: "Тесты для программ обучения"
      });
    }
  }

  protected beforeDestroy() {
    this.watchers.forEach(unwatch => {
      unwatch();
    });
  }

  protected created() {
    this.setTabs();

    this.parseQueryTabId();
  }
}
